import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, User, Building2, ChevronUp, ShieldCheck, Users, CloudUpload } from 'lucide-react';
import Can from './Can';
import { useAuth } from '../context/AuthContext';

/** Anzeigename mit Rückfall auf die E-Mail, falls kein Name hinterlegt ist. */
function anzeigeName(vorname: string | null, nachname: string, email: string): string {
  const name = [vorname, nachname].filter(Boolean).join(' ').trim();
  return name || email;
}

export function BenutzerMenue() {
  const { benutzer, mandant, abmelden } = useAuth();
  const [offen, setOffen] = useState(false);
  const huelle = useRef<HTMLDivElement>(null);

  // Klick daneben schliesst das Menue. Ohne das bliebe es beim Navigieren
  // offen stehen.
  useEffect(() => {
    if (!offen) return;
    function beiKlick(e: MouseEvent) {
      if (!huelle.current?.contains(e.target as Node)) setOffen(false);
    }
    document.addEventListener('mousedown', beiKlick);
    return () => document.removeEventListener('mousedown', beiKlick);
  }, [offen]);

  if (!benutzer) return null;

  return (
    <div className="relative" ref={huelle}>
      {offen && (
        <div className="absolute bottom-full left-0 right-0 mb-2 rounded-lg border border-secondary-200 bg-white py-1 shadow-lg">
          <Link
            to="/profil"
            onClick={() => setOffen(false)}
            className="flex items-center gap-2 px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50"
          >
            <User className="h-4 w-4" />
            Mein Profil
          </Link>
          <Link
            to="/einstellungen/mandant"
            onClick={() => setOffen(false)}
            className="flex items-center gap-2 px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50"
          >
            <Building2 className="h-4 w-4" />
            Unternehmen
          </Link>
          <Can recht="benutzer.lesen">
            <Link
              to="/einstellungen/mitarbeiter"
              onClick={() => setOffen(false)}
              className="flex items-center gap-2 px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50"
            >
              <Users className="h-4 w-4" />
              Mitarbeiter
            </Link>
          </Can>
          <Can recht="ablage.lesen">
            <Link
              to="/einstellungen/ablage"
              onClick={() => setOffen(false)}
              className="flex items-center gap-2 px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50"
            >
              <CloudUpload className="h-4 w-4" />
              Firmenspeicher
            </Link>
          </Can>
          <Can recht="rollen.lesen">
            <Link
              to="/einstellungen/rollen"
              onClick={() => setOffen(false)}
              className="flex items-center gap-2 px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50"
            >
              <ShieldCheck className="h-4 w-4" />
              Rollen und Rechte
            </Link>
          </Can>
          <button
            type="button"
            onClick={() => void abmelden()}
            className="flex w-full items-center gap-2 border-t border-secondary-100 px-3 py-2 text-sm text-red-600 hover:bg-red-50"
          >
            <LogOut className="h-4 w-4" />
            Abmelden
          </button>
        </div>
      )}

      {/*
        Der zugängliche Name muss sagen, was der Knopf TUT. Ohne
        aria-label setzt er sich aus dem Inhalt zusammen — also aus dem
        Namen des Benutzers und der Firma. Eine Vorleseanwendung liest
        dann „Max Mustermann, Musterfirma GmbH, Knopf" vor, und der Hörer
        erfährt nicht, dass sich dahinter Profil, Rollen und Abmelden
        verbergen.
      */}
      <button
        type="button"
        aria-label="Benutzermenü"
        aria-expanded={offen}
        onClick={() => setOffen((o) => !o)}
        className="flex w-full items-center gap-2 rounded-lg px-2 py-2 text-left hover:bg-secondary-100"
      >
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-semibold text-primary-700">
          {(benutzer.vorname?.[0] ?? benutzer.nachname[0] ?? '?').toUpperCase()}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-xs font-medium text-secondary-800">
            {anzeigeName(benutzer.vorname, benutzer.nachname, benutzer.email)}
          </span>
          <span className="block truncate text-[10px] text-secondary-500">
            {mandant?.firma_name ?? ''}
          </span>
        </span>
        <ChevronUp
          className={`h-4 w-4 shrink-0 text-secondary-400 transition-transform ${
            offen ? '' : 'rotate-180'
          }`}
        />
      </button>
    </div>
  );
}

export default BenutzerMenue;
